import React,{useRef,useState} from "react";
import {setEmailAttention} from "@/lib/apiClient";
import {userError} from "@/lib/userError";

export const attentionMessage="Kuitattu: ei tarvitse huomiota. Viesti säilyy Postissa. Tilin turvallisuutta ei tarkistettu.";

export function EmailAttentionButton({emailId,sourceFingerprint,acknowledged=true,disabled=false,onDone,onBusy}) {
  const [busy,setBusy]=useState(false),[error,setError]=useState("");const lock=useRef(false);
  const valid=/^[a-f0-9]{64}$/.test(sourceFingerprint||"");
  const save=async()=>{
    if(lock.current||disabled||!valid)return;
    lock.current=true;setBusy(true);onBusy?.(true);setError("");
    try{await setEmailAttention(emailId,sourceFingerprint,acknowledged);onDone?.(acknowledged?attentionMessage:"Asia palautettiin huomiojonoon.",{actionType:acknowledged?"email_attention_ack":"email_attention_reopen"});}
    catch(failure){setError(userError(failure,"Kuittausta ei voitu vahvistaa. Päivitä asian tila ennen uutta yritystä."));}
    finally{lock.current=false;setBusy(false);onBusy?.(false);}
  };
  return <div className="space-y-1"><button type="button" className="solution-secondary min-h-11 disabled:opacity-40" disabled={busy||disabled||!valid} onClick={save}>{busy?"Tallennetaan…":acknowledged?"Ei tarvitse huomiota":"Palauta huomiojonoon"}</button>{acknowledged&&<p className="text-xs text-muted-foreground">Kuittaa vain tämän huomioasian. Ei muuta Gmailia tai tarkista tilin turvallisuutta. Kuittauksen voi perua.</p>}{error&&<p role="alert" className="text-xs text-amber-400">{error}</p>}</div>;
}
